import { render } from "./MufFin.vue?vue&type=template&id=4731fa38"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/MufFin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4731fa38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4731fa38', __exports__)) {
    api.reload('4731fa38', __exports__)
  }
  
  module.hot.accept("./MufFin.vue?vue&type=template&id=4731fa38", () => {
    api.rerender('4731fa38', render)
  })

}


export default __exports__